// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oUw9zy36m5yvfrJCj1p4{align-items:start;margin-bottom:4px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/rcs/ui/RcsCreate/RcsCreateProfile/BrandTermsSection/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA,CACA,iBAAA","sourcesContent":[".termsAndConditionsCheckbox {\n  align-items: start;\n  margin-bottom: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"termsAndConditionsCheckbox": `oUw9zy36m5yvfrJCj1p4`
};
export default ___CSS_LOADER_EXPORT___;
